import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";

import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import StickyCTA from "@/components/layout/StickyCTA";
import ScrollToTop from "@/components/layout/ScrollToTop";
import LoadingExperience from "@/components/brand/LoadingExperience";

import Home from "@/pages/Home";
import TheFirm from "@/pages/TheFirm";
import Process from "@/pages/Process";
import ClaimServicesHub from "@/pages/ClaimServicesHub";
import ClaimService from "@/pages/ClaimService";
import FloridaCoverageHub from "@/pages/FloridaCoverageHub";
import CityPage from "@/pages/CityPage";
import ResourceCenter from "@/pages/ResourceCenter";
import FreeEvaluation from "@/pages/FreeEvaluation";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import PortalLogin from "@/adjuster-portal/PortalLogin";
import PortalDashboard from "@/adjuster-portal/PortalDashboard";
import PortalAdmin from "@/adjuster-portal/PortalAdmin";
import PortalInviteAccept from "@/adjuster-portal/PortalInviteAccept";
import PublicCard from "@/adjuster-portal/PublicCard";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/the-firm" element={<TheFirm />} />
          <Route path="/process" element={<Process />} />
          <Route path="/claim-services" element={<ClaimServicesHub />} />
          <Route path="/claim-services/:slug" element={<ClaimService />} />
          <Route path="/florida-coverage" element={<FloridaCoverageHub />} />
          <Route path="/florida-coverage/:slug" element={<CityPage />} />
          <Route path="/insights" element={<ResourceCenter />} />
          <Route path="/free-claim-evaluation" element={<FreeEvaluation />} />
          <Route path="/contact" element={<Contact />} />

          {/* Digital Card Portal — isolated from marketing chrome */}
          <Route path="/digital-card/login" element={<PortalLogin />} />
          <Route path="/digital-card/invite/:token" element={<PortalInviteAccept />} />
          <Route path="/digital-card" element={<PortalDashboard />} />
          <Route path="/digital-card/edit" element={<PortalDashboard />} />
          <Route path="/digital-card/admin" element={<PortalAdmin />} />
          <Route path="/card/:slug" element={<PublicCard />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function ChromeAwareShell() {
  const location = useLocation();
  const isPortal = /^\/(digital-card|card\/)/.test(location.pathname);
  return (
    <>
      {!isPortal && <LoadingExperience />}
      <ScrollToTop />
      {!isPortal && <Navigation />}
      <AnimatedRoutes />
      {!isPortal && <Footer />}
      {!isPortal && <StickyCTA />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ChromeAwareShell />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(18, 28, 56, 0.95)",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(198,168,107,0.3)",
              color: "#fff",
              fontFamily: "'Inter Tight', sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
